// // components/Admin/BannerManager.js
// import React, { useState, useEffect } from 'react';
// import { Upload, Trash2, Edit, Move, Eye, EyeOff } from 'lucide-react';
// import { toast } from 'react-toastify';
// import { summaryApi } from '../../common';
// import uploadImage from '../../helpers/uploadImage';

// const BannerManager = () => {
//     const [banners, setBanners] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [uploading, setUploading] = useState(false);
//     const [editingBanner, setEditingBanner] = useState(null);
//     const [formData, setFormData] = useState({
//         title: '',
//         subtitle: '',
//         ctaText: 'Shop Now',
//         ctaLink: '/',
//         isActive: true,
//         order: 0
//     });

//     useEffect(() => {
//         fetchBanners();
//     }, []);

//     const fetchBanners = async () => {
//         try {
//             setLoading(true);
//             const response = await fetch(summaryApi.getAllBanners.url, {
//                 method: summaryApi.getAllBanners.method,
//                 credentials: 'include'
//             });
            
//             if (response.ok) {
//                 const data = await response.json();
//                 if (data.success) {
//                     setBanners(data.banners);
//                 }
//             }
//         } catch (error) {
//             console.error('Error fetching banners:', error);
//             toast.error('Failed to load banners');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleFileUpload = async (event, type) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         // Validate file type
//         const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
//         if (!allowedTypes.includes(file.type)) {
//             toast.error('Please select a valid image file (JPEG, PNG, WebP)');
//             return;
//         }

//         // Validate file size (5MB)
//         if (file.size > 5 * 1024 * 1024) {
//             toast.error('File size must be less than 5MB');
//             return;
//         }

//         try {
//             setUploading(true);
//             console.log(`Uploading ${type} image to Cloudinary...`);
//             const cloudinaryResult = await uploadImage(file);
            
//             console.log('Cloudinary upload successful:', cloudinaryResult);

//             return {
//                 url: cloudinaryResult.secure_url,
//                 publicId: cloudinaryResult.public_id
//             };
//         } catch (error) {
//             console.error('Upload error:', error);
//             toast.error(error.message || `Error uploading ${type} image`);
//             return null;
//         } finally {
//             setUploading(false);
//         }
//     };

//     const handleBannerUpload = async (event) => {
//         const desktopFile = event.target.files[0];
//         if (!desktopFile) return;

//         // Ask for mobile version
//         const mobileFileInput = document.createElement('input');
//         mobileFileInput.type = 'file';
//         mobileFileInput.accept = 'image/*';
//         mobileFileInput.onchange = async (e) => {
//             const mobileFile = e.target.files[0];
//             if (!mobileFile) {
//                 toast.error('Please select both desktop and mobile images');
//                 return;
//             }

//             try {
//                 setUploading(true);

//                 // Upload both images
//                 const [desktopImage, mobileImage] = await Promise.all([
//                     handleFileUpload({ target: { files: [desktopFile] } }, 'desktop'),
//                     handleFileUpload({ target: { files: [mobileFile] } }, 'mobile')
//                 ]);

//                 if (!desktopImage || !mobileImage) {
//                     toast.error('Failed to upload one or both images');
//                     return;
//                 }

//                 // Save to database
//                 const saveResponse = await fetch(summaryApi.uploadBanner.url, {
//                     method: summaryApi.uploadBanner.method,
//                     credentials: 'include',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                     body: JSON.stringify({
//                         desktopImageUrl: desktopImage.url,
//                         mobileImageUrl: mobileImage.url,
//                         desktopPublicId: desktopImage.publicId,
//                         mobilePublicId: mobileImage.publicId,
//                         ...formData,
//                         order: banners.length
//                     }),
//                 });

//                 const saveData = await saveResponse.json();

//                 if (saveData.success) {
//                     toast.success('Banner uploaded successfully!');
//                     setBanners(prev => [...prev, saveData.banner]);
//                     setFormData({
//                         title: '',
//                         subtitle: '',
//                         ctaText: 'Shop Now',
//                         ctaLink: '/',
//                         isActive: true,
//                         order: 0
//                     });
//                 } else {
//                     toast.error(saveData.message || 'Failed to save banner');
//                 }
//             } catch (error) {
//                 console.error('Banner upload error:', error);
//                 toast.error('Error uploading banner');
//             } finally {
//                 setUploading(false);
//             }
//         };

//         mobileFileInput.click();
//     };

//     const toggleBannerStatus = async (bannerId, currentStatus) => {
//         try {
//             const response = await fetch(`${summaryApi.updateBanner.url}/${bannerId}`, {
//                 method: summaryApi.updateBanner.method,
//                 credentials: 'include',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     isActive: !currentStatus
//                 }),
//             });

//             const data = await response.json();

//             if (data.success) {
//                 toast.success(`Banner ${!currentStatus ? 'activated' : 'deactivated'} successfully!`);
//                 setBanners(prev => 
//                     prev.map(banner => 
//                         banner._id === bannerId 
//                             ? { ...banner, isActive: !currentStatus }
//                             : banner
//                     )
//                 );
//             } else {
//                 toast.error(data.message || 'Failed to update banner');
//             }
//         } catch (error) {
//             toast.error('Error updating banner');
//             console.error('Update error:', error);
//         }
//     };

//     const deleteBanner = async (bannerId) => {
//         if (!window.confirm('Are you sure you want to delete this banner?')) {
//             return;
//         }

//         try {
//             const response = await fetch(`${summaryApi.deleteBanner.url}/${bannerId}`, {
//                 method: summaryApi.deleteBanner.method,
//                 credentials: 'include',
//             });

//             const data = await response.json();

//             if (data.success) {
//                 toast.success('Banner deleted successfully!');
//                 setBanners(prev => prev.filter(banner => banner._id !== bannerId));
//             } else {
//                 toast.error(data.message || 'Failed to delete banner');
//             }
//         } catch (error) {
//             toast.error('Error deleting banner');
//             console.error('Delete error:', error);
//         }
//     };

//     if (loading) {
//         return (
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//                 <div className="animate-pulse">
//                     <div className="h-8 bg-gray-200 rounded w-1/4 mb-4"></div>
//                     <div className="space-y-3">
//                         {[1, 2, 3].map(i => (
//                             <div key={i} className="h-20 bg-gray-200 rounded"></div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="bg-white rounded-lg shadow-sm border p-6">
//             <h2 className="text-xl font-bold mb-6">Banner Management</h2>
            
//             <div className="space-y-6">
//                 {/* Upload Section */}
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
//                     <input
//                         type="file"
//                         id="banner-upload"
//                         accept="image/*"
//                         onChange={handleBannerUpload}
//                         className="hidden"
//                         disabled={uploading}
//                     />
//                     <label
//                         htmlFor="banner-upload"
//                         className={`cursor-pointer flex flex-col items-center justify-center ${
//                             uploading ? 'opacity-50' : 'hover:bg-gray-50'
//                         }`}
//                     >
//                         {uploading ? (
//                             <div className="flex flex-col items-center">
//                                 <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
//                                 <p className="text-sm text-gray-600">Uploading to Cloudinary...</p>
//                             </div>
//                         ) : (
//                             <>
//                                 <Upload className="h-8 w-8 text-gray-400 mb-2" />
//                                 <p className="text-sm text-gray-600">
//                                     Click to upload new banner
//                                 </p>
//                                 <p className="text-xs text-gray-500 mt-1">
//                                     You'll be asked to upload both desktop and mobile versions
//                                 </p>
//                             </>
//                         )}
//                     </label>
//                 </div>

//                 {/* Banner List */}
//                 <div className="space-y-4">
//                     <h3 className="text-lg font-medium">Current Banners ({banners.length})</h3>
                    
//                     {banners.length === 0 ? (
//                         <div className="text-center py-8 text-gray-500">
//                             No banners uploaded yet
//                         </div>
//                     ) : (
//                         <div className="grid gap-4">
//                             {banners.map((banner, index) => (
//                                 <div 
//                                     key={banner._id}
//                                     className="border rounded-lg p-4 flex items-center gap-4"
//                                 >
//                                     {/* Banner Preview */}
//                                     <div className="flex-shrink-0">
//                                         <div className="relative">
//                                             <img 
//                                                 src={banner.desktopImage.url} 
//                                                 alt={`Banner ${index + 1}`}
//                                                 className="w-20 h-12 object-cover rounded"
//                                             />
//                                             <div className="absolute -top-1 -right-1">
//                                                 {banner.isActive ? (
//                                                     <Eye className="h-4 w-4 text-green-500" />
//                                                 ) : (
//                                                     <EyeOff className="h-4 w-4 text-gray-400" />
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className="text-xs text-gray-500 mt-1 text-center">
//                                             Desktop
//                                         </div>
//                                     </div>

//                                     <div className="flex-shrink-0">
//                                         <img 
//                                             src={banner.mobileImage.url} 
//                                             alt={`Banner ${index + 1} Mobile`}
//                                             className="w-12 h-12 object-cover rounded"
//                                         />
//                                         <div className="text-xs text-gray-500 mt-1 text-center">
//                                             Mobile
//                                         </div>
//                                     </div>

//                                     {/* Banner Info */}
//                                     <div className="flex-1">
//                                         <h4 className="font-medium text-sm">
//                                             {banner.title || `Banner ${index + 1}`}
//                                         </h4>
//                                         {banner.subtitle && (
//                                             <p className="text-xs text-gray-600 truncate">
//                                                 {banner.subtitle}
//                                             </p>
//                                         )}
//                                         <div className="flex gap-2 mt-1">
//                                             <span className="text-xs px-2 py-1 bg-gray-100 rounded">
//                                                 Order: {banner.order}
//                                             </span>
//                                             {banner.ctaText && (
//                                                 <span className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded">
//                                                     CTA: {banner.ctaText}
//                                                 </span>
//                                             )}
//                                         </div>
//                                     </div>

//                                     {/* Actions */}
//                                     <div className="flex gap-2">
//                                         <button
//                                             onClick={() => toggleBannerStatus(banner._id, banner.isActive)}
//                                             className={`p-2 rounded ${
//                                                 banner.isActive 
//                                                     ? 'text-green-600 hover:bg-green-50' 
//                                                     : 'text-gray-400 hover:bg-gray-50'
//                                             }`}
//                                             title={banner.isActive ? 'Deactivate' : 'Activate'}
//                                         >
//                                             {banner.isActive ? <Eye size={16} /> : <EyeOff size={16} />}
//                                         </button>

//                                         <button
//                                             onClick={() => deleteBanner(banner._id)}
//                                             className="p-2 text-red-600 hover:bg-red-50 rounded"
//                                             title="Delete Banner"
//                                         >
//                                             <Trash2 size={16} />
//                                         </button>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default BannerManager;


import React, { useState, useEffect } from 'react';
import { Upload, Trash2, Eye, EyeOff, Filter, Image, Smartphone, Monitor, AlertCircle, CheckCircle2, Loader2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { summaryApi } from '../../common';
import uploadImage from '../../helpers/uploadImage';
import { authFetch } from '../../helpers/authFetch';

// Banner sections configuration
const BANNER_SECTIONS = {
  header: { 
    label: 'Header Banner', 
    description: 'Top navigation banner',
    icon: '🎯',
    color: 'bg-purple-100 text-purple-800'
  },
  hero: { 
    label: 'Hero Banner', 
    description: 'Main homepage hero section',
    icon: '⭐',
    color: 'bg-blue-100 text-blue-800'
  },
  basic: { 
    label: 'Basic Banner', 
    description: 'Standard promotional banner',
    icon: '📢',
    color: 'bg-green-100 text-green-800'
  },
  featured: { 
    label: 'Featured Products', 
    description: 'Featured products section',
    icon: '🏆',
    color: 'bg-yellow-100 text-yellow-800'
  },
  promotional: { 
    label: 'Promotional', 
    description: 'Special offers and deals',
    icon: '🎁',
    color: 'bg-red-100 text-red-800'
  },
  'mid-page': { 
    label: 'Mid-Page Banner', 
    description: 'Content break banner',
    icon: '📍',
    color: 'bg-indigo-100 text-indigo-800'
  },
  footer: { 
    label: 'Footer Banner', 
    description: 'Bottom page banner',
    icon: '🔻',
    color: 'bg-gray-100 text-gray-800'
  },
  sidebar: { 
    label: 'Sidebar Banner', 
    description: 'Side column banner',
    icon: '📱',
    color: 'bg-pink-100 text-pink-800'
  }
};

// Helper function to safely get section data
const getSectionData = (sectionKey) => {
  const section = BANNER_SECTIONS[sectionKey];
  if (!section) {
    // Return a default section for unknown sections
    return {
      label: sectionKey || 'Unknown Section',
      description: 'Unknown banner section',
      icon: '❓',
      color: 'bg-gray-100 text-gray-800'
    };
  }
  return section;
};

const BannerManager = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedSection, setSelectedSection] = useState('all');
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    ctaText: 'Shop Now',
    ctaLink: '/',
    section: 'hero',
    isActive: true
  });
  const [desktopPreview, setDesktopPreview] = useState(null);
  const [mobilePreview, setMobilePreview] = useState(null);

  useEffect(() => {
    fetchBanners();
  }, [selectedSection]);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const url = selectedSection === 'all' 
        ? summaryApi.getAllBanners.url 
        : `${summaryApi.getAllBanners.url}?section=${selectedSection}`;
      
      const response = await authFetch(url, {
        method: summaryApi.getAllBanners.method,        
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.success) {
        setBanners(data.banners || []);
      } else {
        toast.error(data.message || 'Failed to load banners');
      }
    } catch (error) {
      console.error('Error fetching banners:', error);
      toast.error('Failed to load banners');
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async (file, type) => {
    if (!file) return null;

    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Please select a valid image file (JPEG, PNG, WebP)');
      return null;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error('File size must be less than 5MB');
      return null;
    }

    try {
      console.log(`Uploading ${type} image to Cloudinary...`);
      const cloudinaryResult = await uploadImage(file);
      console.log('Cloudinary upload successful:', cloudinaryResult);
      
      return {
        url: cloudinaryResult.secure_url,
        publicId: cloudinaryResult.public_id
      };
    } catch (error) {
      console.error('Upload error:', error);
      toast.error(`Error uploading ${type} image`);
      return null;
    }
  };

  const handleDesktopImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDesktopPreview(URL.createObjectURL(file));
    }
  };

  const handleMobileImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMobilePreview(URL.createObjectURL(file));
    }
  };

  const handleBannerUpload = async () => {
    const desktopInput = document.getElementById('desktop-upload');
    const mobileInput = document.getElementById('mobile-upload');
    
    const desktopFile = desktopInput?.files[0];
    const mobileFile = mobileInput?.files[0];

    if (!desktopFile || !mobileFile) {
      toast.error('Please select both desktop and mobile images');
      return;
    }

    try {
      setUploading(true);

      const [desktopImage, mobileImage] = await Promise.all([
        handleFileUpload(desktopFile, 'desktop'),
        handleFileUpload(mobileFile, 'mobile')
      ]);

      if (!desktopImage || !mobileImage) {
        toast.error('Failed to upload one or both images');
        return;
      }

      const saveResponse = await authFetch(summaryApi.uploadBanner.url, {
        method: summaryApi.uploadBanner.method,
        
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          desktopImageUrl: desktopImage.url,
          mobileImageUrl: mobileImage.url,
          desktopPublicId: desktopImage.publicId,
          mobilePublicId: mobileImage.publicId,
          section: formData.section,
          title: formData.title,
          subtitle: formData.subtitle,
          ctaText: formData.ctaText,
          ctaLink: formData.ctaLink,
          isActive: formData.isActive
        }),
      });

      const saveData = await saveResponse.json();

      if (saveData.success) {
        toast.success('Banner uploaded successfully!');
        setBanners(prev => [...prev, saveData.banner]);
        
        // Reset form
        setFormData({
          title: '',
          subtitle: '',
          ctaText: 'Shop Now',
          ctaLink: '/',
          section: 'hero',
          isActive: true
        });
        setDesktopPreview(null);
        setMobilePreview(null);
        setShowUploadForm(false);
        
        if (desktopInput) desktopInput.value = '';
        if (mobileInput) mobileInput.value = '';
      } else {
        toast.error(saveData.message || 'Failed to save banner');
      }
    } catch (error) {
      console.error('Banner upload error:', error);
      toast.error('Error uploading banner');
    } finally {
      setUploading(false);
    }
  };

  const toggleBannerStatus = async (bannerId, currentStatus) => {
    try {
      const response = await authFetch(`${summaryApi.updateBanner.url}/${bannerId}`, {
        method: summaryApi.updateBanner.method,
        
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          isActive: !currentStatus
        }),
      });

      const data = await response.json();

      if (data.success) {
        toast.success(`Banner ${!currentStatus ? 'activated' : 'deactivated'} successfully!`);
        setBanners(prev => 
          prev.map(banner => 
            banner._id === bannerId 
              ? { ...banner, isActive: !currentStatus }
              : banner
          )
        );
      } else {
        toast.error(data.message || 'Failed to update banner');
      }
    } catch (error) {
      toast.error('Error updating banner');
      console.error('Update error:', error);
    }
  };

  const deleteBanner = async (bannerId) => {
    if (!window.confirm('Are you sure you want to delete this banner?')) {
      return;
    }

    try {
      const response = await authFetch(`${summaryApi.deleteBanner.url}/${bannerId}`, {
        method: summaryApi.deleteBanner.method,
        
      });

      const data = await response.json();

      if (data.success) {
        toast.success('Banner deleted successfully!');
        setBanners(prev => prev.filter(banner => banner._id !== bannerId));
      } else {
        toast.error(data.message || 'Failed to delete banner');
      }
    } catch (error) {
      toast.error('Error deleting banner');
      console.error('Delete error:', error);
    }
  };

  const getSectionBanners = (section) => {
    return banners.filter(b => b.section === section);
  };

  const filteredBanners = selectedSection === 'all' 
    ? banners 
    : getSectionBanners(selectedSection);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border p-6">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded w-1/4"></div>
          <div className="space-y-3">
            {[1, 2, 3].map(i => (
              <div key={i} className="h-24 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl shadow-lg p-6 text-white">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold mb-2">Banner Management</h2>
            <p className="text-blue-100">Manage banners across different sections of your site</p>
          </div>
          <button
            onClick={() => setShowUploadForm(!showUploadForm)}
            className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-200 flex items-center gap-2 shadow-lg"
          >
            <Upload size={20} />
            Upload Banner
          </button>
        </div>
      </div>

      {/* Upload Form */}
      {showUploadForm && (
        <div className="bg-white rounded-xl shadow-lg border-2 border-blue-200 p-6 animate-fadeIn">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold text-gray-800">Upload New Banner</h3>
            <button
              onClick={() => setShowUploadForm(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Form Fields */}
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">
                  Section <span className="text-red-500">*</span>
                </label>
                <select
                  value={formData.section}
                  onChange={(e) => setFormData({ ...formData, section: e.target.value })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:outline-none transition-colors"
                >
                  {Object.entries(BANNER_SECTIONS).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value.icon} {value.label}
                    </option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">
                  {getSectionData(formData.section).description}
                </p>
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">Title</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  placeholder="Summer Sale 2024"
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:outline-none transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2 text-gray-700">Subtitle</label>
                <input
                  type="text"
                  value={formData.subtitle}
                  onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
                  placeholder="Up to 50% off on selected items"
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:outline-none transition-colors"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold mb-2 text-gray-700">CTA Text</label>
                  <input
                    type="text"
                    value={formData.ctaText}
                    onChange={(e) => setFormData({ ...formData, ctaText: e.target.value })}
                    placeholder="Shop Now"
                    className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:outline-none transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-2 text-gray-700">CTA Link</label>
                  <input
                    type="text"
                    value={formData.ctaLink}
                    onChange={(e) => setFormData({ ...formData, ctaLink: e.target.value })}
                    placeholder="/products"
                    className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:outline-none transition-colors"
                  />
                </div>
              </div>

              <div className="flex items-center gap-3 p-4 bg-blue-50 rounded-lg">
                <input
                  type="checkbox"
                  id="isActive"
                  checked={formData.isActive}
                  onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                  className="w-5 h-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                />
                <label htmlFor="isActive" className="text-sm font-semibold text-gray-700 cursor-pointer">
                  Activate banner immediately after upload
                </label>
              </div>
            </div>

            {/* Image Upload */}
            <div className="space-y-4">
              {/* Desktop Image */}
              <div>
                <label className="text-sm font-semibold mb-2 text-gray-700 flex items-center gap-2">
                  <Monitor size={18} />
                  Desktop Image <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="desktop-upload"
                  accept="image/*"
                  onChange={handleDesktopImageSelect}
                  className="hidden"
                />
                <label
                  htmlFor="desktop-upload"
                  className="block border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition-all"
                >
                  {desktopPreview ? (
                    <div className="relative">
                      <img src={desktopPreview} alt="Desktop preview" className="w-full h-32 object-cover rounded" />
                      <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                        <CheckCircle2 size={16} />
                      </div>
                    </div>
                  ) : (
                    <div className="py-8">
                      <Image className="mx-auto h-12 w-12 text-gray-400 mb-2" />
                      <p className="text-sm text-gray-600">Click to upload desktop image</p>
                      <p className="text-xs text-gray-400 mt-1">Recommended: 1920x600px</p>
                    </div>
                  )}
                </label>
              </div>

              {/* Mobile Image */}
              <div>
                <label className="text-sm font-semibold mb-2 text-gray-700 flex items-center gap-2">
                  <Smartphone size={18} />
                  Mobile Image <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="mobile-upload"
                  accept="image/*"
                  onChange={handleMobileImageSelect}
                  className="hidden"
                />
                <label
                  htmlFor="mobile-upload"
                  className="block border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition-all"
                >
                  {mobilePreview ? (
                    <div className="relative">
                      <img src={mobilePreview} alt="Mobile preview" className="w-full h-32 object-cover rounded" />
                      <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                        <CheckCircle2 size={16} />
                      </div>
                    </div>
                  ) : (
                    <div className="py-8">
                      <Image className="mx-auto h-12 w-12 text-gray-400 mb-2" />
                      <p className="text-sm text-gray-600">Click to upload mobile image</p>
                      <p className="text-xs text-gray-400 mt-1">Recommended: 375x500px</p>
                    </div>
                  )}
                </label>
              </div>
            </div>
          </div>

          {/* Upload Button */}
          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={() => setShowUploadForm(false)}
              className="px-6 py-3 border-2 border-gray-300 rounded-lg font-semibold text-gray-700 hover:bg-gray-50 transition-all"
            >
              Cancel
            </button>
            <button
              onClick={handleBannerUpload}
              disabled={uploading || !desktopPreview || !mobilePreview}
              className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2 shadow-lg"
            >
              {uploading ? (
                <>
                  <Loader2 className="animate-spin" size={20} />
                  Uploading...
                </>
              ) : (
                <>
                  <Upload size={20} />
                  Upload Banner
                </>
              )}
            </button>
          </div>
        </div>
      )}

      {/* Filter Section */}
      <div className="bg-white rounded-xl shadow-sm border p-4">
        <div className="flex items-center gap-3 flex-wrap">
          <Filter className="h-5 w-5 text-gray-500" />
          <span className="text-sm font-semibold text-gray-700">Filter by section:</span>
          <button
            onClick={() => setSelectedSection('all')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              selectedSection === 'all'
                ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            All ({banners.length})
          </button>
          {Object.entries(BANNER_SECTIONS).map(([key, value]) => {
            const count = getSectionBanners(key).length;
            return (
              <button
                key={key}
                onClick={() => setSelectedSection(key)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${
                  selectedSection === key
                    ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <span>{value.icon}</span>
                {value.label} ({count})
              </button>
            );
          })}
        </div>
      </div>

      {/* Banner List */}
      <div className="bg-white rounded-xl shadow-sm border p-6">
        <h3 className="text-lg font-bold mb-4 text-gray-800">
          {selectedSection === 'all' 
            ? `All Banners (${filteredBanners.length})`
            : `${getSectionData(selectedSection).label} (${filteredBanners.length})`
          }
        </h3>
        
        {filteredBanners.length === 0 ? (
          <div className="text-center py-12">
            <AlertCircle className="mx-auto h-16 w-16 text-gray-300 mb-4" />
            <p className="text-gray-500 text-lg">No banners in this section yet</p>
            <p className="text-gray-400 text-sm mt-2">Upload your first banner to get started</p>
          </div>
        ) : (
          <div className="grid gap-4">
            {filteredBanners.map((banner, index) => {
              const sectionData = getSectionData(banner.section);
              return (
                <div 
                  key={banner._id}
                  className="border-2 border-gray-200 rounded-xl p-4 hover:border-blue-300 hover:shadow-md transition-all duration-200 bg-gradient-to-r from-gray-50 to-white"
                >
                  <div className="flex items-center gap-4">
                    {/* Desktop Preview */}
                    <div className="flex-shrink-0">
                      <div className="relative group">
                        <img 
                          src={banner.desktopImage.url} 
                          alt={`Banner ${index + 1}`}
                          className="w-32 h-20 object-cover rounded-lg shadow-sm"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 rounded-lg transition-all flex items-center justify-center">
                          <Monitor className="text-white opacity-0 group-hover:opacity-100 transition-opacity" size={24} />
                        </div>
                        <div className="absolute -top-2 -right-2">
                          {banner.isActive ? (
                            <div className="bg-green-500 text-white p-1 rounded-full shadow-md">
                              <Eye size={16} />
                            </div>
                          ) : (
                            <div className="bg-gray-400 text-white p-1 rounded-full shadow-md">
                              <EyeOff size={16} />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="text-xs text-gray-500 mt-1 text-center font-medium">
                        Desktop
                      </div>
                    </div>

                    {/* Mobile Preview */}
                    <div className="flex-shrink-0">
                      <div className="relative group">
                        <img 
                          src={banner.mobileImage.url} 
                          alt={`Banner ${index + 1} Mobile`}
                          className="w-20 h-20 object-cover rounded-lg shadow-sm"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 rounded-lg transition-all flex items-center justify-center">
                          <Smartphone className="text-white opacity-0 group-hover:opacity-100 transition-opacity" size={20} />
                        </div>
                      </div>
                      <div className="text-xs text-gray-500 mt-1 text-center font-medium">
                        Mobile
                      </div>
                    </div>

                    {/* Banner Info */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-start justify-between mb-2">
                        <h4 className="font-bold text-gray-800 text-lg">
                          {banner.title || `Banner ${index + 1}`}
                        </h4>
                      </div>
                      {banner.subtitle && (
                        <p className="text-sm text-gray-600 mb-2 line-clamp-1">
                          {banner.subtitle}
                        </p>
                      )}
                      <div className="flex gap-2 flex-wrap">
                        <span className={`text-xs px-3 py-1 rounded-full font-semibold ${sectionData.color}`}>
                          {sectionData.icon} {sectionData.label}
                        </span>
                        <span className="text-xs px-3 py-1 bg-gray-100 text-gray-700 rounded-full font-medium">
                          Order: {banner.order}
                        </span>
                        {banner.ctaText && (
                          <span className="text-xs px-3 py-1 bg-blue-100 text-blue-800 rounded-full font-medium">
                            CTA: {banner.ctaText}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-col gap-2">
                      <button
                        onClick={() => toggleBannerStatus(banner._id, banner.isActive)}
                        className={`p-3 rounded-lg transition-all shadow-sm ${
                          banner.isActive 
                            ? 'bg-green-100 text-green-600 hover:bg-green-200' 
                            : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                        }`}
                        title={banner.isActive ? 'Deactivate' : 'Activate'}
                      >
                        {banner.isActive ? <Eye size={18} /> : <EyeOff size={18} />}
                      </button>

                      <button
                        onClick={() => deleteBanner(banner._id)}
                        className="p-3 bg-red-100 text-red-600 hover:bg-red-200 rounded-lg transition-all shadow-sm"
                        title="Delete Banner"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerManager;